import React, { Component } from 'react';
import './Header.css';
import AppHeader from './components/AppHeader/AppHeader';
import LandingHeader from './components/LandingHeader/LandingHeader';

class Header extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
            showAppHeader: window.location.pathname !== '/',
        };

        // Bind state altering functions
        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    render() {
        const navComponent = this.state.showAppHeader ? <AppHeader /> : <LandingHeader />

        return (
            <div className="Header">
                {navComponent}
            </div>
        );
    }
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/App/components/Header/Header.js